var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKiaLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 578.98 136.15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.97 120.65c0 1.07.33 1.68 1 1.68a2.63 2.63 0 001.4-.54L518.75 4.58a17.43 17.43 0 0110.4-3.16h39.66c6.16 0 10.16 4.07 10.16 10.23v75.72c0 9.15-2 14.43-10.16 19.32l-48.1 28.86a3.22 3.22 0 01-1.61.59c-.58 0-1.12-.45-1.12-2.09v-88.4c0-1-.33-1.7-1-1.7a2.73 2.73 0 00-1.39.52l-131.9 85.7a17.36 17.36 0 01-10.13 3.12H286.1c-6.1 0-10.17-4.07-10.17-10.17V13.99c0-.8-.35-1.53-1-1.53a2.72 2.72 0 00-1.42.53l-87 52.26c-.87.52-1.11 1-1.11 1.37s.15.73.77 1.34l62.14 62.15c.83.83 1.4 1.46 1.4 2.11s-.91 1.07-2 1.07h-56.18c-4.41 0-7.81-.67-10.18-3l-37.68-37.73a1.58 1.58 0 00-1.09-.6 2.54 2.54 0 00-1.17.41l-63 37.88c-3.81 2.29-6.45 3-10.18 3h-58c-6.1 0-10.17-4.07-10.17-10.17v-74.3c0-9.15 2-14.4 10.17-19.28L58.64.42A2.44 2.44 0 0159.95 0c.73 0 1.13.77 1.13 2.44v99.38c0 1.05.29 1.53 1 1.53a3 3 0 001.44-.6L226.97 4.47a17.72 17.72 0 0110.79-3h88c6.1 0 10.17 4.07 10.17 10.18z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKiaLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kia_logo.37c8a2b6.svg";
export { ForwardRef as ReactComponent };